import React from 'react';
import { logout } from '../../servicios/auth';
import 'bootstrap/dist/css/bootstrap.min.css';
import './sidebar.css'; // Archivo CSS para los estilos
import { FaBars, FaHome, FaFile, FaSignOutAlt, FaSearch, FaCloudUploadAlt, FaDatabase, FaBolt, FaChartBar, FaCog } from 'react-icons/fa';
import { NavLink, useNavigate } from 'react-router-dom';
const logo = process.env.PUBLIC_URL + '/tigo_logo.svg';

const Sidebar = ({ isOpen, toggleSidebar, onOptionSelect }) => {
   const navigate = useNavigate();
   const handleLogout = async () => {
      await logout();            // cierra la sesión también en el servidor
      navigate('/signin');
   };

   const user = JSON.parse(sessionStorage.getItem('user') || 'null');
   const usu_nombre = user?.userName || user?.userEmail || 'Usuario';
   const usu_correo = user?.userEmail || 'Correo no disponible';

   return (
      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
         <div className="sidebar__top">
            <span className="sidebar__brand">Menú</span>
            <button onClick={toggleSidebar} className="sidebar__collapse" aria-label="Cerrar menú">
               <FaBars />
            </button>
         </div>

         <div className="sidebar__profile">
            <div className="sidebar__logo-wrap">
               <img src={logo} alt="Tigo" className="sidebar__logo" />
            </div>
            <h4 className="sidebar__user-name">{usu_nombre}</h4>
            <span className="sidebar__user-mail">{usu_correo}</span>
         </div>

         <nav className="sidebar__nav">
            <NavLink
               to="/fusion2"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('Lead Fusión')}
            >
               <span className="sidebar__icon"><FaBolt /></span>
               <span>Lead Fusión</span>
            </NavLink>

{/* Oculto temporalmente (2026-09-14): carga a la bitácora Fusión
            <NavLink
               to="/cargar-fusion"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('CargarFusion')}
            >
               <span className="sidebar__icon"><FaCloudUploadAlt /></span>
               <span>Cargar Fusión</span>
            </NavLink>
            */}

            <NavLink
               to="/home"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('Lead Dragon')}
            >
               <span className="sidebar__icon"><FaHome /></span>
               <span>Lead Dragon</span>
            </NavLink>

            <NavLink
               to="/reportes"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('Reportes')}
            >
               <span className="sidebar__icon"><FaChartBar /></span>
               <span>Reportes</span>
            </NavLink>

            <NavLink
               to="/consulta"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('Consulta')}
            >
               <span className="sidebar__icon"><FaSearch /></span>
               <span>Consulta</span>
            </NavLink>

{/* Oculto temporalmente: menús de carga de datos
            <NavLink
               to="/cargar"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('Cargar')}
            >
               <span className="sidebar__icon"><FaCloudUploadAlt /></span>
               <span>Cargar base</span>
            </NavLink>

            <NavLink
               to="/cargar-consulta"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('CargarConsulta')}
            >
               <span className="sidebar__icon"><FaDatabase /></span>
               <span>Bases PRE/POST</span>
            </NavLink>
            */}

            <NavLink
               to="/configuracion"
               className={({ isActive }) => (isActive ? 'sidebar__link active' : 'sidebar__link')}
               onClick={() => onOptionSelect('Configuración')}
            >
               <span className="sidebar__icon"><FaCog /></span>
               <span>Configuración</span>
            </NavLink>
         </nav>

         <div className="sidebar__footer">
            <button onClick={handleLogout} className="sidebar__logout">
               <FaSignOutAlt />
               <span>Cerrar sesión</span>
            </button>
         </div>
      </aside>
   );
};

export default Sidebar;
